module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--search-services search-services"
  }, [_c('div', [_c('div', {
    ref: "main",
    staticClass: "group group--last group--indent group--indent--both"
  }, [_c('h1', {
    staticClass: "h1 mb0",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("Find services")]), _vm._v(" "), _c('p', {
    staticClass: "p mt0"
  }, [_vm._v("Search for services that are appropriate to your need and that are convenient for you.")]), _vm._v(" "), _vm._l((_vm.serviceLinks), function(section, key) {
    return _c('div', {
      key: key
    }, [(section.subcategories.length > 0) ? _c('section', [_c('h3', {
      staticClass: "h2",
      style: ({
        'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
      })
    }, [_vm._v(_vm._s(section.name))]), _vm._v(" "), _c('ul', {
      staticClass: "ml"
    }, _vm._l((section.subcategories), function(providerService, key) {
      return _c('module-service-item', {
        key: key,
        attrs: {
          "arrow": false,
          "service": providerService
        }
      })
    }), 1)]) : _vm._e()])
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78febb54"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/services/ServicesSearch.vue
// module id = 542
// module chunks = 0